module.exports = __webpack_public_path__ + "img/button-mnemonic-hover.2f61f533.svg";